import React from 'react';
export const wrapWithContext = (Context, value, children) => React.createElement(Context.Provider, { value }, children);
